module.exports = __webpack_public_path__ + "static/media/thum3.694c7ab2.jpg";